module.exports = __webpack_public_path__ + "img/main_banner_mobile.868936f2.jpg";